module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fW1uT"))).then(() => parcelRequire('3a9aZ'));